import React from 'react'
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import { useHistory } from 'react-router';
import EmailInput from '../../components/Inputs/EmailInput';
import TextInput from '../../components/Inputs/TextInput';
import ReactSelect from '../../components/Inputs/ReactSelect';
import { COUNTRIES } from '../../helpers/selectOptions';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import useUsers from '../../store/users/usersContext';
import DateInput from '../../components/Inputs/DateInput';

function AddStaff() {
  
  const history = useHistory();

  const {
    inviteStaff
  } = useUsers();

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });

  const [newStaff, _setNewStaff] = React.useState({
    email: null,
    country: null,
    city: null,
    address: null,
    postalCode: null,
    firstName: null,
    lastName: null,
    mobile: null,
    dateOfBirth: null
  });

  const setNewStaff = (newVal) => _setNewStaff({...newStaff, ...newVal});

  const countryOptions = [];
  if (!countryOptions.length) COUNTRIES.forEach(country => {
    countryOptions.push({
      value: country,
      label: country
    })
  });
  
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }


  const handleCreate = () => {
    let element;
    if (!validateEmail(newStaff.email)) {
    element = document.getElementById('email');
    element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'email',
        msg: "Please enter a valid email."
      });
    }
    if (newStaff.firstName === '' || newStaff.firstName === null) {
      element = document.getElementById('firstName');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      
      return setFormError({
        field: 'firstName',
        msg: "Please enter a first name."
      });
    }
    if (newStaff.lastName === '' || newStaff.lastName === null) {
      element = document.getElementById('lastName');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'lastName',
        msg: "Please enter a last name."
      });
    }
    if (newStaff.dateOfBirth === '' || newStaff.dateOfBirth === null) {
      element = document.getElementById('dateOfBirth');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'dateOfBirth',
        msg: "Please enter a date of birth."
      });
    }
    if (newStaff.country === '' || newStaff.country === null ) {
      return setFormError({
        field: 'country',
        msg: "Please enter the country."
      });
    }
    if (newStaff.city=== '' || newStaff.city === null ) {
      return setFormError({
        field: 'city',
        msg: "Please enter the city."
      });
    }
    if (newStaff.address=== '' || newStaff.address === null ) {
      return setFormError({
        field: 'address',
        msg: "Please enter the address."
      });
    }
    if (newStaff.postalCode=== '' || newStaff.postalCode === null ) {
      return setFormError({
        field: 'postalCode',
        msg: "Please enter the postal code."
      });
    }
    if (newStaff.mobile=== '' || newStaff.mobile === null ) {
      return setFormError({
        field: 'mobile',
        msg: "Please enter the mobile number."
      });
    }
    inviteStaff(newStaff).then(() => {
      history.push('/manage-staff');
    });
  }
  
  return (
    <div className="flex flex-col">
      <div className="bg-white rounded shadow py-12 px-10">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Personal Information</h1>
        </div>
        <div className='grid grid-cols-4 gap-y-4 '>
          <EmailInput id='email' horizontal label='Email*'  inputClass='col-span-3' data={newStaff.email} onChange={(e) => setNewStaff({email: e.target.value})} />
          {formError.field === 'email' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput id='firstName' label='First name*' inputClass='col-span-3' /* value={newStaff.firstName} */ onChange={(e) => setNewStaff({firstName: e.target.value})}/>
          {formError.field === 'firstName' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput id='lastName' label='Last name*' inputClass='col-span-3' value={newStaff.lastName} onChange={(e) => setNewStaff({lastName: e.target.value})}/>
          {formError.field === 'lastName' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <DateInput id='dateOfBirth' label='Date of birth*' inputClass='col-span-3' data={newStaff.dateOfBirth} onChange={(e) => setNewStaff({dateOfBirth: e.target.value})} />
          {formError.field === 'dateOfBirth' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
        </div>
      </div>
      <div className="bg-white rounded shadow py-12 px-10 mt-6">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Contact details</h1>
        </div>
        <div className='grid grid-cols-4 gap-y-4'>  
          <ReactSelect label='Country*' options={countryOptions} value={newStaff.country} inputClass='col-span-3' onChange={(e) => setNewStaff({ country: e.value })} /> 
          {formError.field === 'country' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput inputClass='col-span-3' label='City*' data={newStaff.city} onChange={(e) => setNewStaff({city: e.target.value})} />
          {formError.field === 'city' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput inputClass='col-span-3' label='Address*' data={newStaff.address} onChange={(e) => setNewStaff({address: e.target.value})} />
          {formError.field === 'address' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput inputClass='col-span-3' label='Postal code*' data={newStaff.postalCode} onChange={(e) => setNewStaff({postalCode: e.target.value})} />
          {formError.field === 'postalCode' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <TextInput inputClass='col-span-3' label='Mobile*' data={newStaff.mobile} onChange={(e) => setNewStaff({mobile: e.target.value})} />
          {formError.field === 'mobile' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
        </div>
      </div>
      <div className='flex flex-row-reverse mt-8 mb-4'>
        <PrimaryButton text='Create' onClick={handleCreate} className='min-w-180 ml-4'/>
        <SecondaryButton text='Cancel' onClick={() => history.push('/manage-staff')} className='min-w-180'/>
      </div>
    </div>
  )
}

export default AddStaff
